import React, { useContext } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericContext } from "@swiggy-private/portal-dineout-context";

interface IProps {
    query: string;
}

const HomeComponent = ({ query }: IProps) => {
    const { value } = useContext(GenericContext);
    return (
        <Text variant="V2.hero.neutral.bold">
            Query: {query}, Value: {value}
        </Text>
    );
};

export default HomeComponent;
